<template>
  <span
    class="double-check-badge"
    :title="description"
    :aria-description="description"
  ><span aria-hidden="true">🔍</span> Double Check</span>
</template>

<script>
const DESCRIPTION = "Counts for this business are double-checked: count every test twice.";

export default {
  name: "Admin_Tests_DoubleCheckBadge",
  data() {
    return {
      description: DESCRIPTION,
    };
  },
};
</script>

<style scoped>
/* The Special Attention pill's shape and spacing, so the two business flags
   read as a pair wherever they sit side by side. The top margin keeps the gap
   when the pill wraps under the business name in the test list. The wine
   background against white text is about 9.5:1. */
.double-check-badge {
  display: inline-block;
  margin-left: 6px;
  margin-top: 5px;
  background: #7a2650;
  color: #ffffff;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}
</style>
